import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { listBranches, branchesFromEnvelope } from '../features/branch-settings/branchSettingsApi.js';
import { getMerchantRoleCodes } from './merchantNavAccess.js';
import { merchantHomePathFromBranches } from './merchantPreLive.js';

/** Resolves `/` to checklist pre-live, order board post-live (07-07). */
export function MerchantHomeRedirect() {
  const roles = getMerchantRoleCodes();
  const branchesQuery = useQuery({
    queryKey: ['merchant', 'branches'],
    queryFn: listBranches,
  });
  const branches = branchesFromEnvelope(branchesQuery.data);

  if (branchesQuery.isLoading) {
    return null;
  }

  return <Navigate to={merchantHomePathFromBranches(branches, roles)} replace />;
}
